import { render, staticRenderFns } from "./TheMatriculaModal.vue?vue&type=template&id=8f77db3c&scoped=true"
import script from "./TheMatriculaModal.vue?vue&type=script&lang=js"
export * from "./TheMatriculaModal.vue?vue&type=script&lang=js"
import style0 from "./TheMatriculaModal.vue?vue&type=style&index=0&id=8f77db3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f77db3c",
  null
  
)

export default component.exports